<template lang='pug'>
.fpui-status-bar
  .percent(v-if='active')
    | {{ percent.toFixed() }}
    span %
  .bar-container
    .bar
      .gauge(:class='color', :style='{right: `${right}%`}')
    i(:class='className', :style='{left: `calc(${percent}% - 10px)`}')
  .info(ng-if='active') {{ info }}
</template>

<script>

export default {
  props: {
    max: { type: Number, default: 100 },
    min: { type: Number, default: 0 },
    value: { type: Number, default: 0 },
    status: {},
    active: { type: Boolean },
    info: {}
  },
  computed: {
    percent () { return Math.min(100, Math.round(this.value - this.min) / this.max * 100) || 0 },
    right () { return 100 - this.percent },
    className () {
      switch (this.status) {
        case 'Warning': return 'fa fa-exclamation yellow'
        case 'Error': return 'fa fa-exclamation red'
        default: return 'fa fa-check green'
      }
    },
    color () {
      switch (this.status) {
        case 'Warning': return 'yellow'
        case 'Error': return 'red'
        default: return 'green'
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-status-bar {
  width: 100%;
  position: relative;
  margin: 20px 0;
  text-align: center;
  .percent {
    margin-bottom: 10px;
    font-size: 25px;
    span {
      font-size: 15px;
      padding-left: 3px;
    }
  }
  .bar {
    width: 100%;
    height: 5px;
    position: relative;
    background-color: rgba(0,0,0,0.1);
    overflow: hidden;
    border-radius: 5px;
    .gauge {
      background-color: #000;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      transition: all 100ms ease-in-out;
    }
  }
  .bar-container {
    position: relative;
    padding: 7px 0;
  }
  i {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    height: 20px;
    line-height: 20px;
    width: 20px;
    color: #fff;
    border-radius: 15px;
    font-size: 13px;
    text-align: center;
  }
  .bar .gauge, i {
    &.green {
      background-color: @green;
    }
    &.yellow {
      background-color: @yellow;
    }
    &.red {
      background-color: @red;
    }
  }
  .info {
    color: #999;
    font-size: 12px;
    margin-top: 5px;
  }
}

</style>
